jQuery(document).ready(function($) {

    $('[data-action="search-toggle"]').each(function (e) {
        var $label = $(this).closest('label');
        var $input = $('#' + $label.attr('for'));
        var initialWidth = $input.innerWidth();
        $(this).on('click', function (e) {
            if ($input.innerWidth() > initialWidth) {
                if ($input.val() != '') {
                    $(this).closest('form').submit();
                } else {
                    e.preventDefault();
                    $input.blur();
                }
            }
        });
        $input.on('focus', function () {
            $input.closest('.portal-links').addClass('search-expanded');
        });
        $input.on('blur', function () {
            $input.closest('.portal-links').removeClass('search-expanded');
        });
    });

    if ($('#jump-to-search').length) {
        var top = $('#jump-to-search').offset().top;
        var headerHeight = $('#headerMain').outerHeight();
        if ($('#wpadminbar').length) {
            headerHeight += $('#wpadminbar').outerHeight();
        }
        $('html, body').animate({
            scrollTop: Math.max(top - headerHeight, 0)
        }, 800);
    }

    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);

        return (results !== null) ? results[1] || 0 : false;
    };

    var term = $.urlParam('query');
    if (term.length)
    {
        const SEARCH_VALUE = term.trim();

        if (SEARCH_VALUE.length > 0) {
            $('.main-inner').each(function() {
                const DIV_TEXT_CONTENT = $('.main-inner').text();
                const SPLIT_CONTENT = DIV_TEXT_CONTENT.split(" ");

                SPLIT_CONTENT.forEach((word, index) => {
                    const SEARCH_REGEXP = new RegExp(escapeRegExp(SEARCH_VALUE), "gi")
                    if (SEARCH_REGEXP.test(word))
                        $(this).html($(this).html().replace(SEARCH_REGEXP, "<span class = 'highlight'>" + word + "               </span>"));
                });
            });
        }
    }

    function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }
});